import React, { useState } from 'react';
import { Bot, Code, Zap } from 'lucide-react';
import { GetStartedForm } from './GetStartedForm';
import { VideoModal } from './VideoModal';
import { TypewriterEffect } from './TypewriterEffect';
const automationPrompts = ['Automatically processes new shipment requests, checks inventory levels, and sends confirmation emails to customers.', 'Monitors customer support tickets, categorizes them by priority, and routes them to the appropriate team.', 'Extracts data from invoices, reconciles with purchase orders, and flags discrepancies for review.', 'Sync OTA bookings (new, modify, cancel) with PMS, auto-update inventory/rates, and flag mismatches.', 'Extracts data from invoices, flags discrepancies, and routes to appropriate departments.', 'Prepares customs documents with proper HS codes and ensures compliance with trade regulations.'];
export function Hero() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  return <section id="hero" className="bg-gray-50 text-black py-16 md:py-24" data-id="element-289">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24" data-id="element-290">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-291">
          <div data-id="element-292">
            <h1 className="text-4xl md:text-5xl font-bold text-black leading-tight" data-id="element-293">
              Build AI Agents for Your Business in Minutes
            </h1>
            <p className="mt-6 text-xl text-gray-700" data-id="element-294">
              Connect to your existing software and automate tasks with powerful
              AI agents. No coding required — just describe what you need in
              plain English.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0" data-id="element-295">
              <button onClick={() => setIsFormOpen(true)} className="bg-black text-white px-6 py-3 rounded-lg text-center font-medium hover:bg-gray-800 transition-colors" data-id="element-296">
                Get Started Free
              </button>
              <button onClick={() => setIsVideoOpen(true)} className="border border-gray-300 text-black px-6 py-3 rounded-lg text-center font-medium hover:bg-gray-100 transition-colors" data-id="element-297">
                See Demo
              </button>
            </div>
          </div>
          <div className="relative" data-id="element-298">
            <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-299">
              <div className="flex items-center space-x-2 border-b pb-4 mb-4" data-id="element-300">
                <Bot className="text-black" size={24} data-id="element-301" />
                <span className="font-semibold text-gray-800" data-id="element-302">
                  Agent Builder
                </span>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg mb-4" data-id="element-303">
                <p className="text-gray-700 font-medium" data-id="element-304">
                  Create an agent that:
                </p>
                <div className="mt-2" data-id="element-305">
                  <TypewriterEffect prompts={automationPrompts} typingSpeed={40} deletingSpeed={20} delayAfterComplete={2000} data-id="element-306" />
                </div>
              </div>
              <div className="flex justify-end" data-id="element-307">
                <button onClick={() => setIsFormOpen(true)} className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-colors" data-id="element-308">
                  Build Agent
                </button>
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 bg-gray-100 p-4 rounded-lg z-[-1]" data-id="element-309">
              <Code className="text-black" size={32} data-id="element-310" />
            </div>
            <div className="absolute -top-6 -left-6 bg-gray-100 p-4 rounded-lg z-[-1]" data-id="element-311">
              <Zap className="text-black" size={32} data-id="element-312" />
            </div>
          </div>
        </div>
      </div>
      {/* Modals */}
      <GetStartedForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} data-id="element-313" />
      <VideoModal isOpen={isVideoOpen} onClose={() => setIsVideoOpen(false)} data-id="element-314" />
    </section>;
}